/** User */

export class User {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    gender: string;
    dob: string;
    role: string;
    ip_address: string;
}
